module.exports = __webpack_public_path__ + "img/02.05403e2b.jpg";